import RemoteIconV2 from '@/components/Icon/RemoteIconV2';
import {InlineNotification} from '@/components/ui/InlineNotification';
import type {InlineNotificationProps} from '@/components/ui/InlineNotification/InlineNotification';
import useExternalLink from '@/hooks/useExternalLink';
import type {InlineNotificationModel} from '@/types/aem/inlineNotificationModel';
import {twx} from '@/utils/tailwindUtils';

type AemInlineNotificationProps = InlineNotificationProps & {
    model?: InlineNotificationModel | null;
    iconClassName?: string;
};

const AemInlineNotification = ({model, iconClassName, ...inlineProps}: AemInlineNotificationProps) => {
    const {title, description, icon, actionButton} = model ?? {};
    const externalLink = actionButton?.externalLink;
    // @ts-ignore
    const {redirect} = useExternalLink({...externalLink});

    if (!model) {
        return null;
    }

    const mergedProps: InlineNotificationProps = {
        title,
        body: description,
        icon: icon ? <RemoteIconV2 icon={icon} className={twx('h-8 w-8', iconClassName)} /> : undefined,
        actionLabel: actionButton?.text,
        onAction: () => redirect?.(),
        ...inlineProps,
    };

    return <InlineNotification {...mergedProps} />;
};

export default AemInlineNotification;
